module.exports = __webpack_public_path__ + "img/logo-shuyi-dark-mode.e1c91159.svg";